<template>
	<v-container>
		<v-snackbar v-model="statesMessage" :timeout="4000" bottom>{{ stateText }}</v-snackbar>
	</v-container>
</template>

<script>
export default {
	name: 'StateMessages',
	data() {
		return {
			statesMessage: false
		}
	},
	computed: {
		stateText() {
			var msg = this.$store.state.message
			if (msg) {
				this.showSnackbar()
			}
			return msg
		}
	},
	methods: {
		showSnackbar() {
			this.statesMessage = true
		}
	}
}
</script>
<style></style>
